import baseConfig from './baseConfig'

export default {
    runStylesGC: false,
    supportMobile: true,
    postUpdateOperation: false,
    disableAutoSave: true,
    supportedFragments: baseConfig.supportedFragments,
    modulesList: [
        'siteSegmentsPublicAPI',
        'pagePublicAPI',
        'themePublicAPI',
        'componentPublicAPI',
        'componentStylePublicAPI',
        'dataModelPublicAPI',
        'componentsMetaDataPublicAPI',
        'actionsAndBehaviorsPublicAPI',
        'siteMetadataPublicAPI',
        'structurePublicAPI',
        'documentModePublicAPI',
        'menuPublicAPI',
        'mobilePublicAPI',
        'appStudioPublicAPI'
    ],
    extensionsList: [
        ...baseConfig.extensionsList,
        'undoRedo',
        'metadata',
        'lifecycle',
        'contactFormMetaData',
        'appBuilder',
        'save',
        'commonConfig',
        'componentsByType'
    ],
    experimentalConfigOptions: baseConfig.experimentalConfigOptions
}
